import { GraduationCap, Award, Building2 } from "lucide-react";

export default function MentorSection() {
  return (
    <section
      id="mentor"
      data-testid="mentor-section"
      className="py-20 md:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-20 items-center">
          {/* Left - Visual */}
          <div className="lg:col-span-5 flex justify-center lg:justify-start">
            <div className="relative">
              <div className="w-48 h-48 md:w-56 md:h-56 rounded-2xl bg-orange-50 flex items-center justify-center">
                <div className="w-36 h-36 md:w-44 md:h-44 rounded-2xl bg-orange-100 flex items-center justify-center">
                  <span className="font-heading text-5xl md:text-6xl font-bold text-orange-600/70">
                    TO
                  </span>
                </div>
              </div>
              <div className="absolute -bottom-4 -right-4 w-24 h-24 border-2 border-orange-200 rounded-2xl opacity-40"></div>
            </div>
          </div>

          {/* Right - Content */}
          <div className="lg:col-span-7">
            <span className="text-sm font-semibold tracking-wider uppercase text-orange-600 font-body">
              Mentorship
            </span>
            <h2
              data-testid="mentor-title"
              className="font-heading text-3xl md:text-4xl lg:text-5xl font-semibold text-zinc-900 tracking-tight leading-tight mt-4"
            >
              About the Mentor
            </h2>

            <div className="space-y-5 mt-8">
              <p
                data-testid="mentor-desc-1"
                className="font-body text-base md:text-lg text-zinc-600 leading-relaxed"
              >
                Mentored by a former Assistant Professor of Law (LL.B., LL.M., UGC NET) 
                with academic experience at the prestigious National Forensic Sciences University (NFSU), 
                a Central Government University under the Ministry of Home Affairs, Government of India. 
                Having mentored 500+ students and taught across multiple universities, the program is 
                built on strong academic foundations, structured pedagogy, and real classroom 
                experience — combining conceptual clarity with strategic exam-oriented preparation.
              </p>
              <p
                data-testid="mentor-desc-2"
                className="font-body text-base md:text-lg text-zinc-600 leading-relaxed"
              >
                The preparation strategy framework is thoughtfully designed with insights from an alumnus of 
                Indian Institute of Management Ahmedabad (IIM Ahmedabad) and an experienced management consultant 
                bringing analytical depth, structured thinking, and competitive exam precision to the CLAT preparation process.
              </p>
            </div>

            {/* Credentials */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mt-10">
              <div
                data-testid="mentor-credential-1"
                className="flex items-center gap-3 bg-orange-50/60 rounded-xl px-4 py-3"
              >
                <GraduationCap
                  size={20}
                  strokeWidth={1.5}
                  className="text-orange-600 flex-shrink-0"
                />
                <span className="font-body text-sm text-zinc-700 font-medium">
                  LLB, LLM, UGC NET
                </span>
              </div>
              <div
                data-testid="mentor-credential-2"
                className="flex items-center gap-3 bg-orange-50/60 rounded-xl px-4 py-3"
              >
                <Building2
                  size={20}
                  strokeWidth={1.5}
                  className="text-orange-600 flex-shrink-0"
                />
                <span className="font-body text-sm text-zinc-700 font-medium">
                  Former Assistant Professor of Law
                </span>
              </div>
              <div
                data-testid="mentor-credential-3"
                className="flex items-center gap-3 bg-orange-50/60 rounded-xl px-4 py-3"
              >
                <Award
                  size={20}
                  strokeWidth={1.5}
                  className="text-orange-600 flex-shrink-0"
                />
                <span className="font-body text-sm text-zinc-700 font-medium">
                  IIM-A Insights
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
